import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  ast: {
    color: palette.error.main,
    fontSize: '1.25rem',
  },
  form: {
    marginBottom: '0.875rem',
  },
}));
